import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dc0016a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "section-border"
};
const _hoisted_2 = {
  class: "select-title"
};
const _hoisted_3 = {
  class: "flex-between"
};
const _hoisted_4 = {
  class: "section-border"
};
const _hoisted_5 = {
  class: "select-title"
};
const _hoisted_6 = {
  class: "position-right"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg"
}, " 角色组定义了用户可访问的功能模块和可执行操作, 可多选 ", -1));
const _hoisted_8 = {
  style: {
    "text-align": "right"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_tree_select = _resolveComponent("el-tree-select");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_base_option = _resolveComponent("base-option");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("section", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createTextVNode(" 筛选条件 ")]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
    "label-width": "60px",
    style: {
      "display": "flex"
    },
    model: $data.chooseForm
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "姓名"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.chooseForm.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.chooseForm.name = $event),
        placeholder: "请输入姓名",
        clearable: ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "部门"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tree_select, {
        ref: "tree",
        modelValue: $data.chooseForm.dept_ids,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.chooseForm.dept_ids = $event),
        data: _ctx.$store.state.system.organizationList,
        clearable: "",
        multiple: "",
        "collapse-tags": "",
        "show-checkbox": "",
        props: $data.defaultProps,
        onClear: $options.clearDeptIds,
        onChange: $options.getCheckedNodes,
        onRemoveTag: $options.removeTag,
        onCheckChange: $options.getCheckedNodes
      }, null, 8, ["modelValue", "data", "props", "onClear", "onChange", "onRemoveTag", "onCheckChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "状态"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.chooseForm.state,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.chooseForm.state = $event),
        placeholder: "请选择状态",
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.state, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.searchAdmin
  }, {
    default: _withCtx(() => [_createTextVNode(" 查询 ")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    class: "reset-btn",
    onClick: $options.resetForm
  }, {
    default: _withCtx(() => [_createTextVNode(" 重置 ")]),
    _: 1
  }, 8, ["onClick"])])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createTextVNode(" 用户列表 ")]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_table, {
    stripe: "",
    border: "",
    data: $data.adminList,
    "empty-text": "无数据",
    "header-cell-style": {
      background: '#eef1f6',
      color: '#606266'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      label: "姓名",
      prop: "name"
    }), _createVNode(_component_el_table_column, {
      label: "所属部门",
      prop: "department"
    }), _createVNode(_component_el_table_column, {
      label: "状态"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", {
        style: _normalizeStyle({
          color: $options.adminStateColor(scope.row.state)
        })
      }, _toDisplayString(scope.row.state_desc), 5)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "操作"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button, {
        type: "warning",
        disabled: scope.row.state !== 1,
        onClick: $event => $options.showRoleForm(scope.row.id)
      }, {
        default: _withCtx(() => [_createTextVNode(" 配置角色 ")]),
        _: 2
      }, 1032, ["disabled", "onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_6, [_ctx.$store.state.system.adminListLength > $data.pageSize ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    total: _ctx.$store.state.system.adminListLength,
    "current-page": $data.currentPage,
    "page-size": $data.pageSize,
    "page-sizes": [10, 20, 30, 40],
    small: "",
    background: "",
    layout: "total, sizes, prev, pager, next, jumper",
    onSizeChange: $options.changePageSize,
    onCurrentChange: $options.changeCurrentPage
  }, null, 8, ["total", "current-page", "page-size", "onSizeChange", "onCurrentChange"])) : _createCommentVNode("", true)])])), [[_directive_loading, _ctx.$store.state.system.adminLoading]])]), _createVNode(_component_base_option, {
    modelValue: $data.roleVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.roleVisible = $event),
    title: "配置用户角色",
    width: "30%",
    onCloseDialog: $options.closeRoleForm
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "roleForm",
      model: $data.roleForm,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "用户角色组",
        prop: "role_ids",
        rules: [{
          required: true,
          message: '请选择'
        }]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
          modelValue: $data.roleForm.role_ids,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.roleForm.role_ids = $event),
          clearable: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roleList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              key: index,
              label: item.id
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
        class: "close-btn",
        onClick: $options.closeRoleForm
      }, {
        default: _withCtx(() => [_createTextVNode(" 取消 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.submitRoleForm
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue", "onCloseDialog"])]);
}